import { render, staticRenderFns } from "./TipoProductoList.vue?vue&type=template&id=4f005e67&scoped=true&"
import script from "./TipoProductoList.vue?vue&type=script&lang=js&"
export * from "./TipoProductoList.vue?vue&type=script&lang=js&"
import style0 from "./TipoProductoList.vue?vue&type=style&index=0&id=4f005e67&lang=scss&scoped=true&"
import style1 from "./TipoProductoList.vue?vue&type=style&index=1&lang=scss&"
import style2 from "./TipoProductoList.vue?vue&type=style&index=2&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f005e67",
  null
  
)

export default component.exports